import React from 'react'

import Layout from '../../components/Layout'
import BlogRoll from '../../components/BlogRoll'

export default class BlogIndexPage extends React.Component {
  render() {
    return (
      <Layout>
        <div
          className="blog-container margin-top-0"
        >
          <h1
            className="has-text-weight-bold is-size-2"
            style={{
              boxShadow: '0.5rem 0 0 #ff0050, -0.5rem 0 0 #ff0050',
              backgroundColor: '#ff0050',
              color: 'white',
              padding: '1rem',
            }}
          >
            Latest Posts
          </h1>
        </div>
        <section className="section">
          <div className="container">
            <div className="content">
              <BlogRoll />
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}
